import { render, staticRenderFns } from "./CardContratoContratante.vue?vue&type=template&id=28aed50e&lang=pug"
import script from "./CardContratoContratante.vue?vue&type=script&lang=js"
export * from "./CardContratoContratante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports